// extracted by mini-css-extract-plugin
export default {"text":"pages_text__Ld1uH","wrapper":"pages_wrapper__7WcGE","heading":"pages_heading__bda9p","homeLink":"pages_homeLink__v2ySZ"};